export default __webpack_public_path__ + "static/media/photo-portfolio.2a346648.png";